import { msg } from '@lingui/core/macro';

import { defineEnum } from '@/shared/patterns/define-enum';
import type { StatusTone } from '@/shared/patterns/status';

// Enums de Carteiras pelo valor técnico (U33). Leve: entra nos filtros, que vão para o arquivo da rota.

/** "Tipo de cobrança" do "Atualizar carteira" (`UpdateWalletForm.tsx:23-26`), na ordem do legado. */
export const BILLING_TYPE = defineEnum({
  Monthly: { label: msg`Mensal` },
  Daily: { label: msg`Diária` },
});

/**
 * "Tipo de instrução" do filtro de tarifas (`costs.type.ts:27-49`), na ordem do legado. U20-5: acentos
 * corrigidos ("Cartorio", "Confirmacão", "Instrucão", "Titulo", "Debito", "Sustacao").
 */
export const CONFIRMATION_TRANSACTION_TYPE = defineEnum({
  EntradaConfirmada: { label: msg`Entrada Confirmada` },
  EntradaRejeitada: { label: msg`Entrada rejeitada` },
  LiquidacaoNormal: { label: msg`Liquidação Normal` },
  BaixadoAutomaticoViaArquivo: { label: msg`Baixado por arquivo` },
  BaixadoConformeInstrucoesAgencia: { label: msg`Baixado` },
  AbatimentoConcedido: { label: msg`Abatimento Concedido` },
  AbatimentoCancelado: { label: msg`Abatimento Cancelado` },
  VencimentoAlterado: { label: msg`Vencimento Alterado` },
  LiquidacaoCartorio: { label: msg`Liquidação Cartório` },
  LiquidacaoAposBaixaOuTituloNaoRegistrado: { label: msg`Liquidação Após Baixa Ou Título Não Registrado` },
  ConfirmacaoRecebimentoInstrucaoProtesto: { label: msg`Confirmação Recebimento Instrução Protesto` },
  ConfirmacaoRecebimentoInstrucaoSustacaoProtesto: { label: msg`Confirmação Recebimento Instrução Sustação Protesto` },
  AcertoControleParticipante: { label: msg`Acerto Controle Participante` },
  EntradaTituloCartorio: { label: msg`Entrada Título Cartório` },
  EntradaRejeitadaCepIrregular: { label: msg`Entrada Rejeitada Cep Irregular` },
  ConfirmacaoRecebimentoInstrucaoProtestoFalimentar: { label: msg`Confirmação Recebimento Instrução Protesto Falimentar` },
  BaixaRejeitada: { label: msg`Baixa Rejeitada` },
  DebitoTarifasCustas: { label: msg`Débito Tarifas Custas` },
  InstrucaoRejeitada: { label: msg`Instrução Rejeitada` },
  ConfirmacaoPedidoAlteracaoOutrosDados: { label: msg`Confirmação Pedido Alteração Outros Dados` },
  RetiradoCartorioManutencaoCarteira: { label: msg`Retirado Cartório Manutenção Carteira` },
});

/**
 * "Ver tarifas cobradas" (`CostsListContainer.tsx:86-94`): o fio leva o texto `true`/`false`. Na URL
 * vai `sim`/`nao`, porque o roteador lê `true` cru como booleano e o filtro o descartaria.
 */
export const HAS_BILLING_DATE = defineEnum({
  sim: { label: msg`Sim` },
  nao: { label: msg`Não` },
});
export const hasBillingDateParam = (value: string) => (value === 'sim' ? 'true' : 'false');

/**
 * Tom do status da transação de remessa pela cor do legado (`ShowOperationStatus.tsx:16-26`): verde →
 * `ok`, amarelo → `warn`, azul → `info`, vermelho → `err`. O rótulo é o `statusOperationValueDisplay` da API.
 */
export const OPERATION_STATUS_TONE: Readonly<Record<string, StatusTone>> = {
  Registrada: 'ok',
  ProcessadaJd: 'ok',
  ProcessadoUY3: 'ok',
  InformacaoCip: 'warn',
  AguardandoCip: 'warn',
  Desconhecida: 'info',
  ErroJd: 'err',
  ErroCip: 'err',
  ErroUy3: 'err',
};
